module.exports = __webpack_public_path__ + "img/5.78749f0e.png";